import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';

const ProveedoresTable = ({ 
    data, 
    filters, 
    globalFilterFields, 
    onEdit,
    header 
}) => {
    const actionBodyTemplate = (rowData) => {
        return (
            <Button 
                icon="pi pi-pencil" 
                className="p-button-rounded p-button-text" 
                onClick={() => onEdit(rowData)} 
            />
        );
    };

    const categoriaBodyTemplate = (rowData) => {
        return rowData.CATEGORIA || '';
    };

    return (
        <DataTable 
            value={data} 
            scrollable
            scrollHeight="calc(100vh - 190px)"
            virtualScrollerOptions={{ itemSize: 46 }}
            dataKey="ID"
            filters={filters}
            globalFilterFields={globalFilterFields}
            header={header}
            emptyMessage="No se encontraron proveedores."
        >
            <Column field="ID" header="ID" sortable />
            <Column field="NOMBRE" header="Nombre" sortable />
            <Column field="CATEGORIA" header="Categoría" body={categoriaBodyTemplate} sortable />
            <Column field="CORREO" header="Correo" sortable />
            <Column field="TELEFONO" header="Teléfono" sortable />
            <Column field="DIAS_CREDITO" header="Días Crédito" sortable />
            <Column field="RFC" header="RFC" sortable />
            <Column field="ULTIMA_COMPRA_FECHA" header="Última Compra" sortable />
            <Column body={actionBodyTemplate} exportable={false} style={{ minWidth: '8rem' }} />
        </DataTable>
    );
};

export default ProveedoresTable;
